import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { BaseCheckboxComponent2 } from '../shared-components/BaseCheckboxComponent2';
import { getIsReportValidForShowTodayCheckbox, getIsShowTodayDateLineSetForConfigReport, setTodayDateLineForConfigReport } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConfigReportShowTodayCheckbox = ({
  report,
  onChange
}) => {
  const isChecked = getIsShowTodayDateLineSetForConfigReport(report);
  const onShowTodayCheckboxChange = useCallback(newCheckedValue => {
    onChange(setTodayDateLineForConfigReport(report, newCheckedValue));
  }, [report, onChange]);
  if (!getIsReportValidForShowTodayCheckbox({
    report
  })) {
    return null;
  }
  return /*#__PURE__*/_jsx(BaseCheckboxComponent2, {
    isChecked: isChecked,
    onChange: onShowTodayCheckboxChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.show-today-checkbox.config.label"
    })
  });
};